// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"247":"3ee2cc1f","322":"6de74eec","324":"bdfccbc4","371":"ef2a6d5a","562":"69c017c4","580":"b9edc4c5","641":"fbf71637","799":"c84cf194"}[chunkId] + ".js";
};